<template>
  <v-container
    class="pa-0"
  >
    <NoContent
      v-if="shifts.length === 0"
      exciting
      :height="140"
      :width="140"
      :message="$t('descriptions.overtimeNoErrors')"
    />
    <template v-else>
      <div class="mb-2">
        <span class="body-2 grey--text text--darken-3">
          {{ $t('labels.totalWorkingHours') }}
        </span>
        <span class="body-2 error--text">
          {{ error.hours }}
        </span>
        <span class="body-2 grey--text text--darken-3">
          /
        </span>
        <span class="body-2 grey--text text--darken-3">
          {{ user.weeklyHours }}
        </span>
        <span class="body-2 grey--text text--darken-3">
          {{ $t('labels.hrs') }}
        </span>
      </div>
      <ShiftsCard
        v-for="shift in shifts"
        :key="shift.id"
        class="mb-4"
        :shifts="[shift]"
        :show-shift-date="true"
        :user="user"
        @click="$emit('show-shift', shift)"
      />
    </template>
  </v-container>
</template>

<script>
import _ from 'lodash';
import NoContent from '@/components/NoContent';
import ShiftsCard from '@/components/scheduling/ShiftsCard';

export default {
  components: {
    NoContent,
    ShiftsCard
  },
  props: {
    error: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    shifts () {
      const shifts = [];
      for (let date in this.error.data) {
        shifts.push(...this.error.data[date]);
      }
      return _.uniqBy(shifts, 'id');
    }
  }
};
</script>

<style lang="scss">

</style>
